import { AxiosError } from 'axios'
import { HttpError } from './errors/HttpError'
import { LoggerLike } from './LoggerLike'
import { lodash } from './lodash'

export function castToError(value: unknown) {
    if (value instanceof Error) {
        return value
    } else if (lodash.isNil(value)) {
        return new Error('Unknown')
    } else if (lodash.isString(value)) {
        return new Error(value)
    } else if (lodash.isObjectLike(value)) {
        const exn = value as Record<string, unknown>
        if (exn.message) {
            const error = new Error(String(exn.message))
            if (exn.stack) {
                error.stack = String(exn.stack)
            }
            return error
        } else {
            return new Error(JSON.stringify(exn))
        }
    } else {
        return new Error(`Expected exception value ${value}`)
    }
}

export function errorResponse(response: { err?: number; msg?: string }, logger: LoggerLike, caught: unknown) {
    const exn = caught as Record<string, unknown>

    if (exn?.isAxiosError) {
        const error = caught as AxiosError

        if (error.code === 'ECONNABORTED') {
            response.err = 408
            response.msg = 'Request Timeout'
            logger.error(
                `Axios timeout: ${error.message}`,
                error.stack,
                JSON.stringify({
                    url: error.config?.url,
                    method: error.config?.method,
                    timeout: error.config?.timeout
                })
            )
        } else if (error.response) {
            response.err = error.response.status
            response.msg = error.response.statusText || 'HTTP Error'
            logger.error(
                `Axios error: ${error.message}`,
                error.stack,
                JSON.stringify({
                    url: error.config?.url,
                    method: error.config?.method,
                    status: error.response.status,
                    data: error.response.data
                })
            )
        } else {
            response.err = 421
            response.msg = 'Server not able to produce a response'
            logger.error(
                `Axios network error: ${error.message}`,
                error.stack,
                JSON.stringify({
                    url: error.config?.url,
                    method: error.config?.method
                })
            )
        }
    } else if (caught instanceof HttpError) {
        response.err = caught.status
        response.msg = caught.message
        logger.error(`HttpError: ${caught.message}`, caught.stack, JSON.stringify({ status: caught.status }))
    } else if (caught instanceof Error) {
        response.err = 500
        response.msg = caught.message || 'Internal Server Error'
        logger.error(`Generic Error: ${caught.message}`, caught.stack, '')
    } else {
        response.err = 500
        response.msg = String(caught) || 'Internal Server Error'
        logger.error(`Unknown error type`, '', JSON.stringify({ caught }))
    }

    return false
}

export function isHttpError(code: number): boolean {
    return code >= 400
}
